import * as THREE from 'three'

// basic three.js component example

export default class Mouse extends THREE.Group {
  constructor(webgl, options = {}) {
    super(options)
    // these can be used also in other methods
    this.webgl = webgl
    this.options = options

    const mouse = new THREE.Vector2();

    // add it to the group,
    // later the group will be added to the scene
    this.add(this.mouse)
  }
}
